import contentful, {
  flattenEntryResponse,
  flattenEntryResponseSingle,
} from '@aletheia/common/lib/contentful'

import { IPerson } from '../types/generated'

/**
 * Fetch a single Person from Contentful
 *
 * @param {string} slug The slug of this Person
 */
export const fetchPerson = async (
  slug: string,
): Promise<IPerson | undefined> => {
  return flattenEntryResponseSingle(
    await contentful.getEntries({
      content_type: 'person',
      'fields.slug': slug,
      include: 5,
    }),
  ) as IPerson | undefined
}

/**
 * Fetch all Person entries from Contentful
 *
 * @param {object} query Options to pass to contentful.getEntries()
 */
export const fetchPeople = async (
  query?: Record<string, unknown>,
): Promise<IPerson[]> => {
  return flattenEntryResponse(
    await contentful.getEntries({
      include: 5,
      order: 'fields.title',
      ...query,
      content_type: 'person',
    }),
  ) as IPerson[]
}
